
window._ = require('lodash');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

// window.$ = window.jQuery = require('jquery');
// require('bootstrap-sass');

/**
 * Vue is a modern JavaScript library for building interactive web interfaces
 * using reactive data binding and reusable components. Vue's API is clean
 * and simple, leaving you to focus on building your next great project.
 */

window.Vue = require('vue');

/**
 * Vue stash control state of data
 * easily share reactive data between your Vue components.
 */

// window.Vue = require('vue');
// require('vue-stash');

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');
window.axios.defaults.baseURL = '/api',

window.axios.defaults.headers.common = {
  'X-CSRF-TOKEN': window.App.csrfToken,
  'X-Requested-With': 'XMLHttpRequest',
  'Authorization': 'Bearer ' + window.App.jwtToken
};

$.ajaxSetup({
  'Authorization': 'Bearer ' + window.App.jwtToken
});
/**
 * Web socket client
 */
// const ws = require('adonis-websocket-client')
// window.io = ws('', {
//   reconnection: false,
// });

const Pusher = require('pusher-js')
window.pusher = new Pusher(window.Config.PUSH_KEY, {
  cluster: 'ap1',
  authEndpoint: '/pusher/auth',
  auth: {
    headers: {
      'X-CSRF-TOKEN': window.App.csrfToken,
      'X-Requested-With': 'XMLHttpRequest',
      'Authorization': 'Bearer ' + window.App.jwtToken
    }
  }
});

/**
 * Register vex as a global.
 */
window.vex = require('vex-js')
window.vex.registerPlugin(require('vex-dialog'))
window.vex.defaultOptions.className = 'vex-theme-top'



// WEBPACK FOOTER //
// ./resources/assets/js/admin/bootstrap.js